import { render, staticRenderFns } from "./deleteRecord.vue?vue&type=template&id=64faa90b&scoped=true"
import script from "./deleteRecord.vue?vue&type=script&lang=js"
export * from "./deleteRecord.vue?vue&type=script&lang=js"
import style0 from "./deleteRecord.vue?vue&type=style&index=0&id=64faa90b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64faa90b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64faa90b')) {
      api.createRecord('64faa90b', component.options)
    } else {
      api.reload('64faa90b', component.options)
    }
    module.hot.accept("./deleteRecord.vue?vue&type=template&id=64faa90b&scoped=true", function () {
      api.rerender('64faa90b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/assess/staff/deleteRecord.vue"
export default component.exports